(ns frontend.test.tailwind.view
  (:require [ui.util :as uu]))

(defn view
  []
  [:div 
   {:class "m-8 flex gap-8"}
   [:div
    {:class "text-center bg-info-light hover:bg-info-regular underline"}
    "centered?"]
   [:div
    {:class (uu/cm "bg-danger-light text-danger-light-text hover:bg-danger-regular")}
    "blue?"]])
